
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducer';
import { rootSagas } from './saga';

let _store = null;

export function configureStore(anonymous) {
    const sagaMiddleware = createSagaMiddleware();
    _store = createStore(
        rootReducer,
        composeWithDevTools(
            applyMiddleware(sagaMiddleware)
        )
    );

    sagaMiddleware.run(rootSagas, anonymous);
    return _store;
}

export function getStore() {
    return _store;
}

